<template>
  <div v-if="visible">
    <van-popup v-model="visible" position="center" class="HideScrollbar" :close-on-click-overlay="false"
      :style="{ height: '100%', width: '100%', overflow: 'hidden' }">
      <Header title="您可能會喜歡的餐點" l="不加購" @lc="close()" />
      <div class="main">
        <!-- {{ sGetConfig("txtRecommendTypeName") }}
        {{ recommendType }} -->
        <!-- <MenuTB :bkmenu="recommendType" @click="showItem" /> -->

        <!-- <Line1 n="1" :list="getList(mt)" :ordertmp="ordertmp" @click="cmdMI" v-if="sGetConfig('menuLineN') == 1" />
        <Line2 :n="sGetConfig('menuLineN')" :list="getList(mt)" :ordertmp="ordertmp" @click="cmdMI" v-else /> -->
        <Line1 n="1" :list="getList(recommendType[0])"  @click="showItem" v-if="sGetConfig('menuLineN') == 1" />
        <Line2 :n="sGetConfig('menuLineN')" :list="getList(recommendType[0])" @click="showItem" v-else />

      </div>
      <Footer :b1="getBtnText()" @b1c="next()" :anime="!running" />

      <!-- 彈出層視窗 -->
      <FrmItemDetail ref="rFrmItemDetail" @callback="refresh" />
    </van-popup>


  </div>
</template>

<style scoped>
.van-button {
  height: 100%;
}

.van-row {
  line-height: 2rem;
}

.main {
  overflow: scroll;
  height: 100%;
}

/* .van-popup {
  width: 90%;
  height: 90%;
} */
</style>
<script>
// var fits = require("./lib-fits-front")
// import fits from "../../../mixin/lib-fits-front";
var fits = require("../../../mixin/lib-fits-front");
import qs from "qs";
import lodash from "lodash";
import Header from "./Child/Header.vue";
// import CarItem from "./Child/CarItem.vue";
import Line1 from "../MenuTB/Line1.vue";
import Line2 from "../MenuTB/Line2.vue";

export default {
  components: {
    Header,
    Line1,
    Line2,
    // CarItem,
  },
  data() {
    return {
      ordertmp: null,
      rst: [],
      visible: false,
      running: false,
      recommendType: [],
    };
  },
  methods: {
    next() {
      this.$emit("callback");
      this.visible = false;
    },
    findItem(obj) {
      var mi = this.sBKMenu.menuitem.find(
        (r) => (r.TypeNo == obj.TypeNo) & (r.ItemName == obj.ItemName)
      );
      if (!mi) {
        return null;
      }

      var find = this.sBKMenu.extitem.find((r) => r.itemname == obj.ItemName);
      // console.log("find", find);
      if (find) {
        mi.ImgFile = find.imgfile;
        mi.Remark = find.desc;
        mi.DispName = find.dispname;
      }

      if (mi.DispName == "" || mi.DispName == undefined) {
        mi.DispName = obj.ItemName;
      }
      // console.log("mi", mi);
      return mi;
    },
    getList(obj) {
      // this.currentType = obj;
      // this.$store.state.typeid = obj.id;
      // this.list = obj.options;
      var output = [];
      for (let i = 0; i < obj.options.length; i++) {
        var row = this.findItem(obj.options[i]);
        if (row) {
          output.push(row);
        }
        // if (i == 0) output.push(row);
      }
      // this.list = output;
      // output = obj.options;
      return output;
    },
    showItem(obj) {
      // if (!this.checkInputCustCount()) return this.$refs.rFrmInputCustCount.show();
      console.log("showItem", obj);
      this.$refs.rFrmItemDetail.show(obj);
    },
    async cmdOI(obj) {
      try {
        this.gShowLoading();
        var query = { typeno: obj.TypeNo, itemname: obj.ItemName };
        // console.log("query", query);
        let res = await this.apiGetItemC(query);
        // console.log("res", res);

        // console.log("cmdOI");
        var find = this.ordertmp.find((r) => r.rno == obj.rno);
        find.StockQty = res.data.StockQty + find.Qty;

        this.$refs.rFrmItemDetail.show(find);
      } catch (error) {
        console.log(error);
      } finally {
        this.gClearLoading();
      }
    },
    async onDelete(obj) {
      try {
        this.gShowLoading();
        console.log("onDelete", obj);
        obj.Qty = 0;
        var body = { item: obj };
        await this.apiUpdItem(body);
        this.refresh();
        this.gClearLoading();
      } catch (error) {
        console.log(error);
        this.gClearLoading();
      }
    },

    async checkSoldoutNow() { // 檢查商品已停售
      try {
        let res = await this.apiGetStopSale();
        this.$store.commit("setStopSale", res.data);
        let soldoutList = res.data.map(r => r.ItemName);

        let removeList = this.rst.filter(r => soldoutList.includes(r.ItemName));
        let removeText = lodash.uniq(removeList.map(r => r.DispName)).join(", ");
        soldoutList = lodash.uniq(soldoutList);

        let removeListS1 = removeList.map(r => {
          if (r.rno) return r.rno;
          if (r.Parent) return r.Parent;
        }).filter((value, index, self) => self.indexOf(value) === index) // 去重
          .map(rno => this.ordertmp.find(s1 => s1.rno == rno));

        console.log("刪除包含停售商品的組合", removeListS1);

        if (removeListS1.length > 0) {
          await this.gMsgbox(removeText, "部分商品已售完")
            .then(async () => {
              await this.gMsgbox(removeListS1.map(r => r.DispName).join(", "), "自動刪除")
                .then(async () => {
                  for (let i = 0; i < removeListS1.length; i++) {
                    let s1 = this.rst.find(r => r.rno == removeListS1[i].rno);
                    await this.onDelete(s1);
                  }
                });
            });
        }
        return removeListS1.length;
      } catch (error) {
        console.log(error);
      }
    },
    async show(objs, rst) {
      this.rst = rst;


      this.ordertmp = objs;
      console.log(JSON.stringify(this.ordertmp));
      this.rst = rst;

      let txtRecommendTypeName = fits.str(this.sGetConfig("txtRecommendTypeName"));
      this.recommendType = txtRecommendTypeName.split(",");
      if (txtRecommendTypeName == '') return;
      let find = this.sBKMenu.menutype.find(r => r.id == txtRecommendTypeName);
      if (!find) return;

      this.recommendType = [find];

      this.visible = true;


    },
    async refresh() {
      this.gShowLoading();
      // console.log("refresh");
      var res = await this.apiGetOrdertmp();
      this.ordertmp = res.data.objs;
      this.rst = res.data.rst;
      this.gClearLoading();
      if (this.ordertmp.length == 0) {
        this.gMsgbox("您的購物車是空的");
        return this.close();
      }
    },

    dataCheck() {
      var maxQty = Number(this.sConfig.maxQty.value);
      var qty = this.gSum(this.ordertmp, "Qty");
      if (qty > maxQty) {
        this.gMsgbox("數量上限:" + maxQty + "，請刪除部分品項");
        return false;
      }
      return true;
    },
    getNextSendTime() {
      let cSendTime = fits.val(this.sGetConfig("cSendTime"));
      return fits.dateAdd(fits.now(), cSendTime);
      // return fits.now();
    },
    async beforeSend() {
      let soldoutLength = await this.checkSoldoutNow();
      console.log("soldoutLength", soldoutLength);
      if (soldoutLength == 0) {
        if (this.sGetConfig("chkBeforeSendConfirm")) {
          this.gSure("確認傳送")
            .then(() => {
              this.send();
            })
            .catch(() => {
              return;
            });
        } else {
          this.send();
        }
      }


    },
    async send() {
      try {
        if (!this.checkCSendTime())
          return this.gMsgbox("每次傳送需間隔" + this.sGetConfig("cSendTime") + "分鐘");

        if (this.gOverSendTime())
          return this.gMsgbox(this.sGetConfig("txtOverMaxOrderTimeText"));
        // console.log("send");
        if (!this.dataCheck()) {
          return;
        }

        // if (confirm == "cancel") return;

        // }

        this.running = true;

        // var tblid = this.$route.query.tblid;
        // var passcode = this.$route.query.PassCode;
        var remark = this.sPotype;
        this.sTblid != "" && (remark += "," + this.sTblid);
        this.sPhone != "" && (remark += "," + this.sPhone);

        var tblid = this.sTblid;
        if (this.sPassCode == "") tblid = "";

        //為了做到分區送預點單，所以桌號不能傳mpo，bnserv需開參數POrder(即使有桌號也會寫入訂單)
        if (this.sTblid != "" && this.sConfig.printpo_by_area.value) tblid = this.sTblid;

        if (this.sPassCode != "") remark = ""; //大巨星，在內用點餐時，orderh.remark有其它用途，不要寫入

        if (this.sGetConfig("kioskMode") && fits.str(this.sTblid) != "") remark = ""; //大巨星，在KIOSK時，tblid=自助點餐1~2，不要寫入po_h.remark;


        if (this.sGetConfig("chkSetPohRemarkIsNull")) remark = ""; //張耀芳.聰明鴨肉店：備註=>不要自動帶入[內用]

        var body = {
          tblid: tblid,
          passcode: this.sPassCode,
          rst: this.rst,
          remark: remark,
          custtotal: this.sCustCount,
        };
        var res = await this.apiSendOrdertmp(body);
        var code = res.data.code;
        var title = this.sGetConfig("sendOkMsg");
        title || (title = "傳送完成");

        let msg = "";

        let cSendTime = fits.val(this.sGetConfig("cSendTime"));
        if (cSendTime > 0) {
          let nextSendTime = this.getNextSendTime();
          nextSendTime = nextSendTime.substr(11, 5);
          msg = "下次可送單時間為 <span class='C4'>" + nextSendTime + "</span>";
        }

        if (code == "0000") {
          this.gMsgbox(msg, title).then(() => {
            return (window.location.href = "/?" + qs.stringify(this.$route.query));
          });
        } else {
          let errmsg = res.data;
          // alert(errmsg);
          if (typeof errmsg == "object") errmsg = JSON.stringify(errmsg);
          await this.gMsgbox(errmsg).then(() => {
            setTimeout(() => {
              // this.running = false;
            }, 1000);
          });
        }
      } catch (error) {
        await this.gMsgbox(error).then(() => {
          setTimeout(() => {
            // this.running = false;
          }, 1000);
        });
      } finally {
        // setTimeout(() => {
        //   this.running = false;
        // }, 6000);

        this.running = false;

      }
    },
    async close() {
      this.$emit("callback");
      this.visible = false;
    },
    sum() {
      var output = {};
      output.Qty = this.gSum(this.ordertmp, "Qty");
      output.Amt = this.gSum(this.rst, "Amt");
      return output;
    },
    getBtnText() {
      var sum = this.sum();

      if (this.sGetConfig("chkCartNoSumAmt"))
        return "合計" + sum.Qty + "份 " + "購物車 Shopping Cart";

      return "合計" + sum.Qty + "份 $" + sum.Amt + " 購物車 Shopping Cart";
      // if (sum.Qty == 0) {
      //   this.anime = false;
      //   return "確認送出 Submit";
      // } else {
      //   this.anime = true;
      //   return "餐點共" + sum.Qty + "份  $" + sum.Amt + "元 Order Detail";
      // }
    },

    checkCSendTime() {
      if (!this.sOrderI) return true;
      let orderi = this.sOrderI.filter((r) => r.POSID == "eat");
      if (orderi == 0) return true;

      let lastSendTime = orderi[orderi.length - 1].FileDate; // 最後傳送時間
      let now = fits.now();
      let time = fits.dateAdd(lastSendTime, this.sGetConfig("cSendTime")); // 下次可傳送時間
      if (now > time) return true;
      // console.log("lastSendTime", lastSendTime);
      // console.log("now", fits.now());
      // console.log("time", time);
      return false;
    },
  },
};
</script>
